const MEDIA_ITEMS = [
  {
    img: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20entertainment%20news%20studio%20with%20warm%20coral%20pink%20lighting%2C%20abstract%20geometric%20shapes%2C%20soft%20bokeh%20background%2C%20modern%20magazine%20style%2C%20clean%20aesthetic&width=640&height=360&seq=media-card-01&orientation=landscape',
    title: '明星私服大盘点：今夏最会穿的女艺人TOP10',
    duration: '08:24',
    views: '128万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20illustration%20of%20a%20talk%20show%20set%20design%2C%20soft%20golden%20and%20rose%20gradients%2C%20minimalist%20geometric%20composition%2C%20editorial%20style%2C%20clean%20backdrop&width=640&height=360&seq=media-card-02&orientation=landscape',
    title: '综艺名场面：那些年让人笑到头掉的爆笑片段合集',
    duration: '12:56',
    views: '215万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20illustration%20of%20a%20film%20premiere%20red%20carpet%20scene%2C%20soft%20coral%20and%20cream%20colors%2C%20geometric%20shapes%2C%20glamorous%20editorial%20style%2C%20modern%20design&width=640&height=360&seq=media-card-03&orientation=landscape',
    title: '红毯精彩瞬间：本届电影节高光时刻全收录',
    duration: '06:38',
    views: '89万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Warm%20pastel%20abstract%20illustration%20of%20music%20concert%20vibes%2C%20soft%20peach%20and%20cream%20gradients%2C%20flowing%20shapes%2C%20rhythmic%20composition%2C%20editorial%20magazine%20style&width=640&height=360&seq=media-card-04&orientation=landscape',
    title: '独家专访：新生代偶像的真实日常大揭秘',
    duration: '15:20',
    views: '342万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Soft%20warm%20abstract%20illustration%20of%20a%20behind%20the%20scenes%20film%20set%2C%20coral%20and%20golden%20tones%2C%20minimalist%20composition%20with%20camera%20shapes%2C%20clean%20editorial%20aesthetic&width=640&height=360&seq=media-card-05&orientation=landscape',
    title: '剧组探班：年度最受期待大戏拍摄现场直击',
    duration: '10:42',
    views: '176万',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
            视频专区
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">精彩视频</h2>
          <p className="text-sm text-foreground-500 mt-2">边看边吃瓜，精彩内容一网打尽</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {MEDIA_ITEMS.map((item, i) => (
            <div key={i} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/5 transition-colors"></div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-white text-xs font-mono">
                  {item.duration}
                </div>
                <div className="absolute top-2 left-2 w-9 h-9 flex items-center justify-center rounded-full bg-white/90 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                  <i className="ri-play-fill text-lg"></i>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-800 leading-snug line-clamp-2 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-400">{item.views} 次播放</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}